import { render } from "./checkTitle1226.vue?vue&type=template&id=71506992&scoped=true&ts=true"
import script from "./checkTitle1226.vue?vue&type=script&lang=ts"
export * from "./checkTitle1226.vue?vue&type=script&lang=ts"

import "./checkTitle1226.vue?vue&type=style&index=0&id=71506992&lang=less&scoped=true"

import exportComponent from "/workspace/source-code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71506992"]])

export default __exports__